export default function MinimumDepartmentResourcesDirective() {
  return {
    template: require('./minimum-department-resources.html'),
    scope: {
      assessmentId: '=',
      status: '@',
    },
    controller: 'MinimumDepartmentResourcesController',
    controllerAs: 'minimumDepartmentResourcesVM',
    bindToController: true,
    replace: true,
  };
}
